import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
// import * as AiIcons from 'react-icons/ai';
import * as BsCaretRight from "react-icons/bs";
import * as BsCaretLeft from "react-icons/bs";
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import './SidebarComp/Trellosidebar.css';
import { IconContext } from 'react-icons';

function Trellosidebar() {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>

        <div className='sidemenu-dev'>
          <Link to='#' className='menu-bars'>
            <BsCaretRight.BsCaretRight onClick={showSidebar} />
          </Link>
        </div>


        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className='nav-menu-items' onClick={showSidebar}>
            <div className='boarddivcntr'>Wajahat ullah  workspace  free
              <li className='navbar-toggle'>
                {/* <div className = 'boarddivcntr'>wajahat  */}
                <Link to='#' className='menu-bars'>
                  <BsCaretLeft.BsCaretLeft />

                </Link>
              </li>
            </div>
            <hr style={{ width: "200px", border: '1px solid darkgray' }}/>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>   {item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Trellosidebar;
